import request from "root/js/request";

const getRefundsAndTransfersTables = async ({
  wb_api_key_ids,
  date_from,
  date_to,
  category_id__in,
  brand_id__in,
  supplier_article__in,
  barcode__in,
  product_id__in,

  group_by,
  order_by,
  subject_id__in,
  limit,
  offset,
  q,
  product_id__icontains,
  supplier_article,
  supplier_article__icontains,
  ...rest
}) => {
  const response = await request({
    url: "/analytics/ride_returns_table/",

    method: "get",
    params: {
      wb_api_key_ids,
      date_from,
      date_to,
      category_id__in,
      brand_id__in,
      supplier_article__in,
      barcode__in,
      product_id__in,

      group_by,
      order_by,
      subject_id__in,
      limit,
      offset,
      q,
      product_id__icontains,
      supplier_article,
      supplier_article__icontains,
      ...rest,
    },
  });
  return response.data;
};

export { getRefundsAndTransfersTables };
